// Clarity Call booking statuses, in the server's order (server/constants/clarityCall.js).
export const BOOKING_STATUSES = [
  "REQUESTED",
  "PENDING",
  "CONFIRMED",
  "CANCELLED",
  "COMPLETED",
  "NO_SHOW",
];

// The same statuses for the audience pickers (Bulk Message, Autoresponder), with CANCELLED
// last: it's the one an empty selection leaves out.
export const BOOKING_STATUS_OPTIONS = [
  ...BOOKING_STATUSES.filter((s) => s !== "CANCELLED"),
  "CANCELLED",
];
